import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">zo0.cc · Your Short Domain Solution</p>
        <h1>Unlock Your Digital Potential.</h1>
        <p className="lede">
          Discover the power of short domain names tailored for your digital services and marketing needs. 
          Elevate your online presence with a memorable domain that stands out.
        </p>
        <div className="cta-row">
          <a href="/get-started" target="_blank">
            Get Started
          </a>
          <a href="/learn-more" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Fast and Simple Registration</h2>
          <p>
            Secure your short domain in just a few clicks. Our streamlined process ensures you can focus on what matters most—your business.
          </p>
        </article>
        <article>
          <h2>Boost Your Brand Visibility</h2>
          <p>
            A concise domain name enhances your brand's recognition and makes it easier for customers to find you online.
          </p>
        </article>
        <article>
          <h2>Comprehensive Support</h2>
          <p>
            Our dedicated team is here to assist you with every step, from domain selection to marketing strategies.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;